import { render, staticRenderFns } from "./ExpensesModal.vue?vue&type=template&id=532cf07e&scoped=true&"
import script from "./ExpensesModal.vue?vue&type=script&lang=js&"
export * from "./ExpensesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532cf07e",
  null
  
)

export default component.exports